import useCommonOrdersQuery from "@repo/shopify/queries/useOrdersQuery";

import useLanguage from "@hooks/useLanguage";

import { useCustomerStore } from "@store/customer";
import { useLayoutStore } from "@store/layout";

export default function useOrders() {
  const { lang } = useLanguage();

  const { token } = useCustomerStore();
  const { openToast } = useLayoutStore();

  return useCommonOrdersQuery({
    lang,
    accessToken: token.accessToken,
    first: 10,
    openToast,
  });
}
